import React from 'react'

const Checked = (props) => (
    <svg width={props.width ? props.width : '11'}
         height={props.height ? props.height : '8'}
         fill={props ? props.color : '#1D79FB'}
         viewBox="0 0 11 8"
         xmlns="http://www.w3.org/2000/svg"
    >
        <path fillRule="evenodd" clipRule="evenodd"
              d="M3.63971 5.19666L8.83636 0L10.2249 1.3885L3.63971 7.97366L0 4.33395L1.3885 2.94545L3.63971 5.19666Z"
              />
    </svg>
)

export default Checked
